import { useEffect, useMemo, useState } from 'react';
import { GridRowId } from '@mui/x-data-grid-pro';
import { Device } from '@src/types/Device';

// Custom hook to manage expanded rows in a data grid
export default function useExpandedRows(
  devices: Device[] | undefined,
  maxInitialExpanded = 6,
): { expandedRowIds: GridRowId[] } {
  const initialExpandedIds = useMemo(() => {
    if (!devices || devices.length === 0) {
      return [];
    }

    return devices
      .slice(0, maxInitialExpanded)
      .map((device) => device.engineeringId);
  }, [devices, maxInitialExpanded]);

  const [expandedRowIds, setExpandedRowIds] =
    useState<GridRowId[]>(initialExpandedIds);

  useEffect(() => {
    setExpandedRowIds(initialExpandedIds);
  }, [initialExpandedIds]);

  return { expandedRowIds };
}
